/* global BigInt */
// Inteiros em centavos; arredondamento monetário apenas ao fim do pró-rata.
const invalido = message => Object.assign(new Error(message), { status: 422 });
function centavos(value) {
  let s = String(value ?? '').replace(/R\$|\s/g, '');
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  if (!/^-?\d+(\.\d{1,2})?$/.test(s)) throw invalido('Valor monetário inválido');
  const [whole, fraction = ''] = s.replace('-', '').split('.');
  const n = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  if (!Number.isSafeInteger(n)) throw invalido('Valor monetário fora do limite');
  return s.startsWith('-') ? -n : n;
}
function distribuir(total, quantidade) {
  if (!Number.isSafeInteger(total) || total < 0 || !Number.isInteger(quantidade) || quantidade <= 0 || quantidade > 1000) throw invalido('Distribuição inválida');
  const base = Math.floor(total / quantidade), resto = total % quantidade;
  return Array.from({ length: quantidade }, (_, i) => base + (i < resto ? 1 : 0));
}
function calcularPlano({ referencia, quantidade, duracao, dias, desconto = 0 }) {
  const ref = centavos(referencia), desc = centavos(desconto);
  if (ref <= 0 || !Number.isInteger(quantidade) || quantidade <= 0 || !Number.isInteger(duracao) || duracao <= 0 || !Number.isInteger(dias) || dias <= 0 || desc < 0 || desc > 10000) throw invalido('Parâmetros contratuais inválidos');
  const numerador = BigInt(ref) * BigInt(quantidade) * BigInt(dias) * BigInt(10000 - desc);
  const denominador = BigInt(duracao) * 10000n;
  const result = Number((numerador + denominador / 2n) / denominador);
  if (!Number.isSafeInteger(result)) throw invalido('Total fora do limite');
  return result;
}
function redistribuir(total, linhas, protegido = p => p.data_pagamento || p.data_recebimento || p.bloqueado_edicao) {
  const fixas = linhas.filter(protegido), livres = linhas.filter(p => !protegido(p));
  const restante = total - fixas.reduce((s,p) => s + centavos(p.valor), 0);
  if (!livres.length) {
    if (restante !== 0) throw invalido('Sem parcelas livres para distribuir o saldo');
    return;
  }
  const valores = distribuir(restante, livres.length);
  livres.forEach((p,i) => { p.valor = (valores[i] / 100).toFixed(2); });
}
module.exports = { centavos, distribuir, calcularPlano, redistribuir };
